import React, {useEffect, useState} from "react";
import CountriesSelector from "../../../contriesSelector/CountriesSelector";
import {RefreshIcon} from "../../../../assets/icons/RefreshIcon";
import {getTwilioPhoneNumbers} from "../../../../api/getTwilioPhoneNumbers";
import useUserContext from "../../../../hooks/useUserContext";
import useAppContext from "../../../../hooks/useAppContext";
import Loader from "../../../loader/Loader";
import {formatPhoneNumber} from "../../../../utils/friendlyPhone";
import useToast from "../../../../hooks/useToast";
import {BigInput} from "../../../forms/bigInput/BigInput";
import {cleanPhoneNumberOnlyDigits} from "../../../../utils/cleanPhoneNumberString";
import Checkbox from "../../../forms/checkbox/Checkbox";

export interface PhoneNumberObj {
    phoneNumber?: string, price?: number, priceToShow?: number, isoCountry?: string, token?: string
}

const EMPTY_PHONE_NUMBER_OBJ: PhoneNumberObj = { phoneNumber: undefined, price: undefined, isoCountry: 'US', token: undefined };

const BYON_TR = {
    en: {
        condition1: "This phone number is not used as a private WhatsApp Account",
        condition2: "This phone number is not used as another WhatsApp Business Account",
    },
    he: {
        condition1: "מספר טלפון זה אינו בשימוש כחשבון WhatsApp פרטי",
        condition2: "מספר טלפון זה אינו בשימוש כחשבון WhatsApp Business אחר",
    },
};

export const TwilioPhoneByonPicker = ({ label, lang = "en", onNumberChange, disabled = false }: { label?: string, lang?: "en" | "he", onNumberChange: (payload: PhoneNumberObj, isApproved?: boolean) => void, disabled?: boolean }) => {
    const tr = BYON_TR[lang];
    const { selectedDomain } = useUserContext();
    const { data: { shop }} = useAppContext();
    const pricingPlan = shop?.data?.pricingPlan;
    const includedPhoneNumberIso = pricingPlan?.includedPhoneNumberIso || false;
    const [phoneNumberCondition1, setPhoneNumberCondition1] = useState(false);
    const [phoneNumberCondition2, setPhoneNumberCondition2] = useState(false);

    const [selectedPhoneNumberObj, setSelectedPhoneNumberObj] = useState<PhoneNumberObj>(EMPTY_PHONE_NUMBER_OBJ);
    const [phoneNumberSelection, setPhoneNumberSelection] = useState<any[]>([]);

    const onCountryChange = async (newCountryCode: string) => {
        console.log("111");
        try {
            console.log("newCountryCode: ", newCountryCode);
            const countryISO2 = newCountryCode.split(' ');
            console.log("countryISO2: ", countryISO2);
            if(countryISO2[0]) {
                setSelectedPhoneNumberObj({...selectedPhoneNumberObj, isoCountry: countryISO2[0]});
            }
        } catch(error) {
            setSelectedPhoneNumberObj(EMPTY_PHONE_NUMBER_OBJ);
        }
    }

    useEffect(() => {
        setSelectedPhoneNumberObj({ ...EMPTY_PHONE_NUMBER_OBJ, isoCountry: selectedPhoneNumberObj.isoCountry });
        onCountryChange(`${selectedPhoneNumberObj.isoCountry} XX`);
    }, [shop.data]);

    useEffect(() => {
        const isApproved = phoneNumberCondition1 && phoneNumberCondition2;
        onNumberChange(selectedPhoneNumberObj, isApproved);
    }, [selectedPhoneNumberObj, phoneNumberCondition1, phoneNumberCondition2]);

    return (
        <div className="phone-number-byon-picker">
            <div className="phone-field-container">
                {label ? <div className="description">{label}</div> : null}
                <div className="phone-field">
                    <CountriesSelector isDisabled={disabled} selectedCountry={selectedPhoneNumberObj.isoCountry || 'US'} setSelectedCountry={onCountryChange} valueProp="country" hideCountryName={true} />
                    <span className="phone-separator">-</span>
                    <BigInput isDisabled={disabled} placeholder="Phone Number" maxLength={14} value={selectedPhoneNumberObj?.phoneNumber || ''} setValue={(newVal: string) => setSelectedPhoneNumberObj({ phoneNumber: cleanPhoneNumberOnlyDigits(newVal), price: 0, isoCountry: selectedPhoneNumberObj?.isoCountry || 'US' })} />
                </div>
                <div className='custom-number-container byon-conditions'>
                    <div className="byon-conditions-list">
                        <Checkbox label={tr.condition1} isSelected={phoneNumberCondition1} setIsSelected={() => setPhoneNumberCondition1(!phoneNumberCondition1)} />
                        <Checkbox label={tr.condition2} isSelected={phoneNumberCondition2} setIsSelected={() => setPhoneNumberCondition2(!phoneNumberCondition2)} />
                    </div>
                </div>
            </div>
        </div>
    )
}